import RELEASING_AutoCompleteComboBox from "components/General/AutoCompleteComboBox/RELEASING_AutoCompleteComboBox";
import FormInputError from "components/General/FormInputError";
import { Controller } from "react-hook-form";

export default function PortalType({
  errors,
  setValue,
  control,
  setError,
  selectedOption,
  setSelectedOption,
}) {
  return (
    <div>
      <Controller
        name="portal"
        control={control}
        render={() => (
          <RELEASING_AutoCompleteComboBox
            labelName="Portal Type"
            inputPlaceholderText="Select"
            options={[
              {
                value: "",
                displayAs: "",
                selectedPolicyDisplayAs: "Select",
                isDisplayOnly: true,
              },
              {
                value: "agent",
                displayAs: "Agent",
                selectedPolicyDisplayAs: "Agent",
                isDisplayOnly: true,
              },
              {
                value: "customer",
                displayAs: "Customer",
                selectedPolicyDisplayAs: "Customer",
                isDisplayOnly: true,
              },
              {
                value: "both",
                displayAs: "Both",
                selectedPolicyDisplayAs: "Both",
                isDisplayOnly: true,
              },
            ]}
            selectedOption={selectedOption}
            setSelectedOption={(option) => {
              if (option?.value) {
                setError("portal", {
                  message: "",
                });
                setValue("portal", option?.value);
                setSelectedOption({ value: option?.value });
              } else {
                setValue("portal", "");
                setSelectedOption({ value: "" });
                setError("portal", {
                  message: "This is a required field.",
                });
              }
            }}
          />
        )}
        rules={{
          required: "This is a required field.",
        }}
      />

      <FormInputError
        id={`portal-type-error`}
        errorMessage={errors?.portal?.message}
      />
    </div>
  );
}
